import React from "react"

const SVG = ({
  width = '100%',
  className = '',
  viewBox = '0 0 54 55'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>D1540221-E0D3-4788-8802-723ABF7C0F86</title>
    <desc>Created with sketchtool.</desc>
    <defs>
      <linearGradient x1="50%" y1="23.8878038%" x2="50%" y2="63.8183594%" id="linearGradient-1">
        <stop stopColor="#DFDCDB" offset="0%" />
        <stop stopColor="#B7B5B7" offset="100%" />
      </linearGradient>
      <path d="M351,40.8857143 L335.483925,51.3282793 C334.112091,52.2515452 333.366295,51.7057581 333.815431,50.1188105 L339,31.8 L324.916912,21.4602092 C323.582088,20.4801827 323.84559,19.5886853 325.486486,19.4703622 L343.5,18.1714286 L349.933398,1.28529102 C350.522466,-0.260872517 351.480568,-0.252909333 352.066602,1.28529102 L358.5,18.1714286 L376.513514,19.4703622 C378.162905,19.5892979 378.417389,20.4805664 377.083088,21.4602092 L363,31.8 L368.184569,50.1188105 C368.634919,51.7100475 367.887603,52.2513393 366.516075,51.3282793 L351,40.8857143 Z" id="path-1" />
      <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-3">
        <feOffset dx="0" dy="3" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0" type="matrix" in="shadowOffsetOuter1" />
      </filter>
    </defs>
    <g id="MVP---Android-Lobby-F&amp;F" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Video-Visit---Receipt-w.-Feedback---More-3" transform="translate(-435.000000, -309.000000)">
        <g id="Group-2" transform="translate(20.000000, 122.000000)">
          <g id="Receipt-Copy" transform="translate(0.000000, 102.000000)">
            <g id="Group-3" transform="translate(52.000000, 32.000000)">
              <g id="Group" transform="translate(39.000000, 53.000000)">
                <g id="Star-1">
                  <use fill="black" fillOpacity="1" filter="url(#filter-3)" xlinkHref="#path-1" />
                  <use fill="#E1DEDC" fillRule="evenodd" xlinkHref="#path-1" />
                  <use fill="url(#linearGradient-1)" fillRule="evenodd" xlinkHref="#path-1" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default SVG